module.exports = __webpack_public_path__ + "static/manna-sm-620e0b95c24bbe4bc8650988147ceb6b.jpg";